import { IPointOfSale } from '../../../services/stock/models/stockItems.service.model';
import { getLanguageLongString } from '@utils/getLanguageLongString';
import i18next from 'i18next';
import { IDealer } from '../../../interfaces/Dealer';

const getDealerName = (pointOfSale: IDealer | undefined) => {
    if (!pointOfSale) {
        return '';
    }

    const longLangLabel = getLanguageLongString(i18next.language);

    const localizedValue = Object.entries(pointOfSale.name).find(([lang]) => lang === longLangLabel)?.[1];
    const fallbackValue = Object.values(pointOfSale.name)[0];

    return localizedValue ?? fallbackValue;
};

export default getDealerName;
